/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus\":\"Circle with plus sign\"}");